import { UPDATE_DOWNLOAD_STATUS } from './actionTypes'

export const updateDownloadStatus = ({ flag, systemType, downloadType, fileName, selectedVersion, selectedType, _url }) => ({ type: UPDATE_DOWNLOAD_STATUS, flag, systemType, downloadType, fileName, selectedVersion, selectedType, _url })